// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2Ufmd","inputWrap":"CustomTip_inputWrap__2eeIW"};